import { Component, Input } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { SelectOption, TemplateSelectComponent } from "../../templates/template-select/template-select.component";

@Component({
  standalone: true,
  selector: "app-prefix-idt",
  imports: [TemplateSelectComponent],
  templateUrl: "./prefix-idt.component.html",
  styleUrl: "./prefix-idt.component.less",
})
export class PrefixIdtComponent extends PrefixComponent<string> {
  @Input()
  public options: SelectOption[];
  public multiple: boolean;

  public constructor() {
    super();
    this.options = [];
    this.multiple = false;
    this.required = true;
    this.characters = ALLOWED_CHARACTERS["idt"];
  }
}
